/*! mfac-presentation-os.js — Canvas Gallery guard; YOUR SELECTION sync; Metal→Aluminum labels;
   collector-audit 2026-09-24: invalid combos inert/snap + no stale price; inquiry + selected panel. */
(function () {
  'use strict';

  function productRoot() {
    return (
      document.querySelector('.product-section[data-product-handle]') ||
      document.querySelector('[data-section-type="product"]') ||
      document.querySelector('.product-section') ||
      document
    );
  }

  function isLancePhotoContext(pr) {
    if (!pr) return false;
    if (document.querySelector('[data-mfac-presentation-os]')) return true;
    var tpl = (pr.getAttribute('data-product-template') || '').toLowerCase();
    if (tpl.indexOf('lance-open-edition') !== -1 || tpl.indexOf('open-edition') !== -1) return true;
    var pres = pr.querySelector(
      '.variant-input-wrap[data-handle="presentation"], .variant-input-wrap[name="Presentation"], .variant-input-wrap[data-handle="material"], .variant-input-wrap[name="Material"]'
    );
    return !!pres;
  }

  function selectedValue(pr, handles) {
    for (var i = 0; i < handles.length; i++) {
      var h = handles[i];
      var wrap =
        pr.querySelector('.variant-input-wrap[data-handle="' + h + '"]') ||
        pr.querySelector('.variant-input-wrap[name="' + h + '"]') ||
        pr.querySelector('.variant-input-wrap[data-mfac-option-name="' + h + '"]');
      if (!wrap) continue;
      var checked = wrap.querySelector('input[type="radio"]:checked');
      if (checked) return checked.value || '';
    }
    var wraps = pr.querySelectorAll('.variant-input-wrap');
    for (var j = 0; j < wraps.length; j++) {
      var name = (wraps[j].getAttribute('name') || wraps[j].getAttribute('data-mfac-option-name') || '').toLowerCase();
      for (var k = 0; k < handles.length; k++) {
        if (name === handles[k].toLowerCase() || name.replace(/\s+/g, '-') === handles[k].toLowerCase()) {
          var c = wraps[j].querySelector('input[type="radio"]:checked');
          if (c) return c.value || '';
        }
      }
    }
    return '';
  }

  function displayPresentation(v) {
    if (!v) return '';
    if (/^metal$/i.test(v)) return 'Aluminum';
    return v;
  }

  function displayFrame(v) {
    if (!v) return '';
    if (/^luxury$/i.test(v) || /^deep$/i.test(v) || /^wide gallery$/i.test(v) || /^wide gallery frame$/i.test(v)) return 'Gallery';
    if (/luxury\s*w/i.test(v) || /deep\s*w/i.test(v) || /gallery\s*\+\s*border/i.test(v) || /wide gallery \+ border/i.test(v) || /gallery w\/ border/i.test(v))
      return 'Gallery + Border';
    if (/^no frame$/i.test(v)) return 'Unframed';
    if (/w\/ border/i.test(v)) return v.replace(/w\/ border/i, '+ Border');
    return v;
  }

  function isGalleryFrame(v) {
    return /gallery/i.test(v || '') || /luxury/i.test(v || '') || /^deep/i.test(v || '');
  }

  function hideInput(el, hide) {
    if (!el) return;
    el.classList.toggle('mfac-pres-hidden', !!hide);
    el.style.display = hide ? 'none' : '';
    var input = el.querySelector('input[type="radio"]');
    if (input) {
      if (hide) {
        input.setAttribute('disabled', 'disabled');
        if (input.checked) input.checked = false;
      } else {
        input.removeAttribute('disabled');
      }
    }
  }

  function setInert(el, inert) {
    if (!el) return;
    el.classList.toggle('mfac-pres-inert', !!inert);
    var input = el.querySelector('input[type="radio"]');
    if (input) {
      if (inert) {
        input.setAttribute('disabled', 'disabled');
        input.setAttribute('aria-disabled', 'true');
      } else if (!el.classList.contains('mfac-pres-hidden')) {
        input.removeAttribute('disabled');
        input.removeAttribute('aria-disabled');
      }
    }
  }

  function frameWrap(pr) {
    return (
      pr.querySelector('.variant-input-wrap[data-handle="frame"]') ||
      pr.querySelector('.variant-input-wrap[name="Frame"]') ||
      pr.querySelector('.variant-input-wrap[data-handle="frame-style"]') ||
      pr.querySelector('.variant-input-wrap[name="Frame Style"]')
    );
  }

  function sizeWrap(pr) {
    return (
      pr.querySelector('.variant-input-wrap[data-handle="size"]') ||
      pr.querySelector('.variant-input-wrap[name="Size"]') ||
      pr.querySelector('.variant-input-wrap[data-handle="image-size"]') ||
      pr.querySelector('.variant-input-wrap[name="Image Size"]')
    );
  }

  function loadVariants(pr) {
    if (window.MFAC_OR_VARIANTS && window.MFAC_OR_VARIANTS.length) return window.MFAC_OR_VARIANTS;
    var script =
      pr.querySelector('[data-product-json], script[type="application/json"][data-product-json]') ||
      ((pr && pr.getAttribute('data-product-id')) ? document.getElementById('ProductJson-' + pr.getAttribute('data-product-id')) : null) ||
      document.querySelector('script[id^="ProductJson-"], script[data-product-json]'); /* SEOMATOR 2026-10-15: was an unrendered Liquid selector in a static asset */
    // Theme often has: var product = { variants: [...] } inside Product section JSON
    var mfacCurHandle = (pr && pr.getAttribute('data-product-handle')) || ((location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1]) || '';
    var candidates = document.querySelectorAll('script[type="application/json"]');
    for (var i = 0; i < candidates.length; i++) {
      var raw = (candidates[i].textContent || '').trim();
      if (!raw || raw[0] !== '{') continue;
      try {
        var obj = JSON.parse(raw);
        if (obj && Array.isArray(obj.variants) && obj.variants.length && mfacCurHandle && obj.handle === mfacCurHandle) {
          window.MFAC_OR_VARIANTS = obj.variants;
          return obj.variants;
        }
        if (obj && Array.isArray(obj.variants) && obj.variants.length > 10 && obj.options && (!obj.handle || obj.handle === mfacCurHandle)) {
          // Prefer product-shaped JSON near product section
          window.MFAC_OR_VARIANTS = obj.variants;
          return obj.variants;
        }
      } catch (e) {}
    }
    // Fallback: ShopifyAnalytics meta
    try {
      var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product;
      if (meta && Array.isArray(meta.variants)) {
        window.MFAC_OR_VARIANTS = meta.variants.map(function (v) {
          return {
            id: v.id,
            available: v.available !== false,
            option1: v.public_title ? v.public_title.split(' / ')[0] : (v.options && v.options[0]),
            option2: v.options && v.options[1],
            option3: v.options && v.options[2],
            options: v.options,
            price: v.price,
            name: v.name
          };
        });
        return window.MFAC_OR_VARIANTS;
      }
    } catch (e2) {}
    return [];
  }

  function variantOptions(v) {
    if (v.options && v.options.length) return v.options;
    return [v.option1, v.option2, v.option3].filter(function (x) { return x != null; });
  }

  function findVariant(variants, presentation, size, frame) {
    for (var i = 0; i < variants.length; i++) {
      var opts = variantOptions(variants[i]);
      if (!opts.length) continue;
      var p = opts[0] || '';
      var s = opts[1] || '';
      var f = opts[2] || '';
      // Metal stored as Aluminum display — match either
      var pOk =
        p === presentation ||
        (/^aluminum$/i.test(presentation) && /^metal$/i.test(p)) ||
        (/^metal$/i.test(presentation) && /^aluminum$/i.test(p));
      if (pOk && s === size && f === frame) return variants[i];
    }
    return null;
  }

  function sizesForPresentation(variants, presentation) {
    var set = {};
    variants.forEach(function (v) {
      var opts = variantOptions(v);
      var p = opts[0] || '';
      var pOk =
        p === presentation ||
        (/^aluminum$/i.test(presentation) && /^metal$/i.test(p)) ||
        (/^metal$/i.test(presentation) && /^aluminum$/i.test(p));
      if (pOk && opts[1]) set[opts[1]] = true;
    });
    return set;
  }

  function framesFor(variants, presentation, size) {
    var set = {};
    variants.forEach(function (v) {
      var opts = variantOptions(v);
      var p = opts[0] || '';
      var pOk =
        p === presentation ||
        (/^aluminum$/i.test(presentation) && /^metal$/i.test(p)) ||
        (/^metal$/i.test(presentation) && /^aluminum$/i.test(p));
      if (pOk && opts[1] === size && opts[2]) set[opts[2]] = true;
    });
    return set;
  }

  function moneyFromCents(cents) {
    var dollars = Number(cents) / 100;
    if (!isFinite(dollars)) return '';
    try {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD',
        maximumFractionDigits: 0
      }).format(dollars);
    } catch (e) {
      return '$' + Math.round(dollars);
    }
  }

  function announce(msg) {
    var live = document.querySelector('[data-mfac-sel-status]');
    if (!live) {
      live = document.querySelector('[data-mfac-selected-artwork]');
    }
    if (live) {
      if (live.hasAttribute('data-mfac-sel-status')) {
        live.hidden = !msg;
        live.textContent = msg || '';
      }
    }
    var region = document.querySelector('[data-mfac-picker-announce]');
    if (!region) {
      region = document.createElement('div');
      region.className = 'visually-hidden';
      region.setAttribute('role', 'status');
      region.setAttribute('aria-live', 'polite');
      region.setAttribute('data-mfac-picker-announce', '1');
      document.body.appendChild(region);
    }
    region.textContent = msg || '';
  }

  function setPriceUnavailable(pr, unavailable, priceCents) {
    var nodes = pr.querySelectorAll('[data-product-price], [data-mfac-sel-price]');
    nodes.forEach(function (n) {
      if (n.hasAttribute('data-mfac-sel-price')) return; // handled in panel
      if (unavailable) {
        if (!n.getAttribute('data-mfac-price-prev')) n.setAttribute('data-mfac-price-prev', n.textContent || '');
        n.textContent = 'Unavailable';
        n.setAttribute('data-mfac-unavailable', '1');
      } else {
        n.removeAttribute('data-mfac-unavailable');
        if (priceCents != null && isFinite(priceCents)) {
          // Theme usually updates; if not, set
          if (n.getAttribute('data-mfac-force-price') === '1' || !n.textContent || /unavailable/i.test(n.textContent)) {
            n.textContent = moneyFromCents(priceCents);
          }
        }
      }
    });
    var submit = pr.querySelector('button[type="submit"][name="add"], .add-to-cart, [name="add"]');
    if (submit) {
      if (unavailable) {
        submit.setAttribute('disabled', 'disabled');
        submit.setAttribute('aria-disabled', 'true');
      } else {
        submit.removeAttribute('disabled');
        submit.removeAttribute('aria-disabled');
      }
    }
    var idInput = pr.querySelector('select[name="id"], input[name="id"]');
    if (idInput && unavailable) {
      // leave value but mark
      idInput.setAttribute('data-mfac-invalid-combo', '1');
    } else if (idInput) {
      idInput.removeAttribute('data-mfac-invalid-combo');
    }
  }

  function applyCanvasGalleryGuard(pr) {
    var presentation = selectedValue(pr, ['presentation', 'material', 'Presentation', 'Material']);
    var fw = frameWrap(pr);
    if (!fw) return;
    var canvas = /^canvas$/i.test(presentation);
    fw.querySelectorAll('.variant-input').forEach(function (el) {
      var v = el.getAttribute('data-value') || el.getAttribute('data-mfac-option-value') || '';
      hideInput(el, canvas && isGalleryFrame(v));
    });
    var checked = fw.querySelector('input[type="radio"]:checked');
    var checkedWrap = checked && checked.closest('.variant-input');
    if (canvas && (!checked || (checkedWrap && checkedWrap.classList.contains('mfac-pres-hidden')))) {
      var prefer = Array.prototype.find.call(fw.querySelectorAll('.variant-input'), function (el) {
        if (el.classList.contains('mfac-pres-hidden')) return false;
        var v = el.getAttribute('data-value') || '';
        return /^unframed$/i.test(v) || /^no frame$/i.test(v);
      });
      if (!prefer) {
        prefer = Array.prototype.find.call(fw.querySelectorAll('.variant-input'), function (el) {
          return !el.classList.contains('mfac-pres-hidden');
        });
      }
      if (prefer) {
        var inp = prefer.querySelector('input');
        if (inp) {
          inp.checked = true;
          inp.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }
  }

  function applyAvailabilityGuards(pr) {
    var variants = loadVariants(pr);
    if (!variants.length) return null;
    var presentation = selectedValue(pr, ['presentation', 'material', 'Presentation', 'Material']);
    var size = selectedValue(pr, ['size', 'image-size', 'Size', 'Image Size']);
    var frame = selectedValue(pr, ['frame', 'frame-style', 'Frame', 'Frame Style']);
    var sizeOk = sizesForPresentation(variants, presentation);
    var sw = sizeWrap(pr);
    if (sw) {
      sw.querySelectorAll('.variant-input').forEach(function (el) {
        var v = el.getAttribute('data-value') || '';
        var ok = !!sizeOk[v];
        setInert(el, !ok);
      });
      // If current size invalid for presentation → snap to nearest valid (prefer 20x60)
      if (size && !sizeOk[size]) {
        var preferOrder = ['20" x 60"', '20″ x 60″', '30" x 90"', '30″ x 90″'];
        var target = null;
        for (var i = 0; i < preferOrder.length; i++) {
          if (sizeOk[preferOrder[i]]) {
            target = preferOrder[i];
            break;
          }
        }
        if (!target) {
          target = Object.keys(sizeOk)[0];
        }
        if (target) {
          var tEl = Array.prototype.find.call(sw.querySelectorAll('.variant-input'), function (el) {
            return (el.getAttribute('data-value') || '') === target;
          });
          if (tEl) {
            var tin = tEl.querySelector('input');
            if (tin && !tin.checked) {
              tin.checked = true;
              size = target;
              announce('Size ' + target + ' selected — ' + displayPresentation(presentation) + ' is not offered at the previous size.');
              tin.dispatchEvent(new Event('change', { bubbles: true }));
              return { snapped: true };
            }
          }
        }
      }
    }

    size = selectedValue(pr, ['size', 'image-size', 'Size', 'Image Size']);
    frame = selectedValue(pr, ['frame', 'frame-style', 'Frame', 'Frame Style']);
    var frameOk = framesFor(variants, presentation, size);
    var fw = frameWrap(pr);
    if (fw) {
      fw.querySelectorAll('.variant-input').forEach(function (el) {
        if (el.classList.contains('mfac-pres-hidden')) return;
        var v = el.getAttribute('data-value') || '';
        setInert(el, !frameOk[v]);
      });
      if (frame && !frameOk[frame]) {
        var fPrefer = ['Unframed', 'Black', 'Natural', 'White'];
        var ft = null;
        for (var j = 0; j < fPrefer.length; j++) {
          if (frameOk[fPrefer[j]]) {
            ft = fPrefer[j];
            break;
          }
        }
        if (!ft) ft = Object.keys(frameOk)[0];
        if (ft) {
          var fEl = Array.prototype.find.call(fw.querySelectorAll('.variant-input'), function (el) {
            return (el.getAttribute('data-value') || '') === ft && !el.classList.contains('mfac-pres-hidden');
          });
          if (fEl) {
            var fin = fEl.querySelector('input');
            if (fin && !fin.checked) {
              fin.checked = true;
              frame = ft;
              announce('Frame updated to ' + displayFrame(ft) + ' for this presentation and size.');
              fin.dispatchEvent(new Event('change', { bubbles: true }));
              return { snapped: true };
            }
          }
        }
      }
    }

    var match = findVariant(variants, presentation, size, frame);
    if (!match) {
      setPriceUnavailable(pr, true);
      announce('That combination is not available. Choose a listed size and frame.');
      updateInquiryAndPanel(pr, null, presentation, size, frame, true);
      return { available: false };
    }
    setPriceUnavailable(pr, false, match.price);
    // Sync hidden variant id if present
    var idInput = pr.querySelector('input[name="id"]');
    if (idInput && match.id) idInput.value = String(match.id);
    var sel = pr.querySelector('select[name="id"]');
    if (sel && match.id) sel.value = String(match.id);
    updateInquiryAndPanel(pr, match, presentation, size, frame, false);
    // history URL without reload
    try {
      if (match.id && window.history && window.history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', String(match.id));
        window.history.replaceState({}, '', u.pathname + u.search + u.hash);
      }
    } catch (e3) {}
    return { available: true, variant: match };
  }

  
  // OR finished outer sizes — geometry calibrated to producer frame profiles (see assets/mfac-or-outer-dims.json).
  // Never invent weights. Never name the production lab.
  var MFAC_OR_OUTER = {"acrylic|20x60|unframed": {"display": "About 20\u00d760 in (approx.)", "outer_in": [20.0, 60.0], "outer_mm": [508, 1524], "note": "Approximate finished outer size from locked frame geometry. Confirm before a tight install."}, "aluminum|20x60|unframed": {"display": "About 20\u00d760 in (approx.)", "outer_in": [20.0, 60.0], "outer_mm": [508, 1524], "note": "Approximate finished outer size from locked frame geometry. Confirm before a tight install."}, "acrylic|20x60|black": {"display": "About 21.7\u00d761.7 in (approx.)", "outer_in": [21.73, 61.73], "outer_mm": [552, 1568], "note": "Approximate finished outer size from locked frame geometry. Confirm before a tight install."}, "aluminum|20x60|black": {"display": "About 21.7\u00d761.7 in (approx.)", "outer_in": [21.73, 61.73], "outer_mm": [552, 1568], "note": "Approximate finished outer size from locked frame geometry. Confirm before a tight install."}, "acrylic|20x60|natural": {"display": "About 21.7\u00d761.7 in (approx.)", "outer_in": [21.73, 61.73], "outer_mm": [552, 1568], "note": "Approximate finished outer size from locked frame geometry. Confirm before a tight install."}, "aluminum|20x60|natural": {"display": "About 21.7\u00d761.7 in (approx.)", "outer_in": [21.73, 61.73], "outer_mm": [552, 1568], "note": "Approximate finished outer size from locked frame geometry. Confirm before a tight install."}, "acrylic|20x60|white": {"display": "About 21.7\u00d761.7 in (approx.)", "outer_in": [21.73, 61.73], "outer_mm": [552, 1568], "note": "Approximate finished outer size from locked frame geometry. Confirm before a tight install."}, "aluminum|20x60|white": {"display": "About 21.7\u00d761.7 in (approx.)", "outer_in": [21.73, 61.73], "outer_mm": [552, 1568], "note": "Approximate finished outer size from locked frame geometry. Confirm before a tight install."}, "acrylic|20x60|black + border": {"display": "About 25.7\u00d765.7 in (approx.)", "outer_in": [25.67, 65.67], "outer_mm": [652, 1668], "note": "Approximate finished outer size from locked frame geometry. Confirm before a tight install."}, "aluminum|20x60|black + border": {"display": "About 25.7\u00d765.7 in (approx.)", "outer_in": [25.67, 65.67], "outer_mm": [652, 1668], "note": "Approximate finished outer size from locked frame geometry. Confirm before a tight install."}, "acrylic|20x60|natural + border": {"display": "About 25.7\u00d765.7 in (approx.)", "outer_in": [25.67, 65.67], "outer_mm": [652, 1668], "note": "Approximate finished outer size from locked frame geometry. Confirm before a tight install."}, "aluminum|20x60|natural + border": {"display": "About 25.7\u00d765.7 in (approx.)", "outer_in": [25.67, 65.67], "outer_mm": [652, 1668], "note": "Approximate finished outer size from locked frame geometry. Confirm before a tight install."}, "acrylic|20x60|white + border": {"display": "About 25.7\u00d765.7 in (approx.)", "outer_in": [25.67, 65.67], "outer_mm": [652, 1668], "note": "Approximate finished outer size from locked frame geometry. Confirm before a tight install."}, "aluminum|20x60|white + border": {"display": "About 25.7\u00d765.7 in (approx.)", "outer_in": [25.67, 65.67], "outer_mm": [652, 1668], "note": "Approximate finished outer size from locked frame geometry. Confirm before a tight install."}, "acrylic|20x60|gallery": {"display": "About 28.0\u00d768.0 in (approx.)", "outer_in": [28.03, 68.03], "outer_mm": [712, 1728], "note": "Approximate finished outer size from locked frame geometry. Confirm before a tight install."}, "aluminum|20x60|gallery": {"display": "About 28.0\u00d768.0 in (approx.)", "outer_in": [28.03, 68.03], "outer_mm": [712, 1728], "note": "Approximate finished outer size from locked frame geometry. Confirm before a tight install."}, "acrylic|20x60|gallery + border": {"display": "About 32.2\u00d772.2 in (approx.)", "outer_in": [32.2, 72.2], "outer_mm": [818, 1834], "note": "Approximate finished outer size from locked frame geometry. Confirm before a tight install."}, "aluminum|20x60|gallery + border": {"display": "About 32.2\u00d772.2 in (approx.)", "outer_in": [32.2, 72.2], "outer_mm": [818, 1834], "note": "Approximate finished outer size from locked frame geometry. Confirm before a tight install."}, "acrylic|30x90|unframed": {"display": "About 30\u00d790 in (approx.)", "outer_in": [30.0, 90.0], "outer_mm": [762, 2286], "note": "Approximate finished outer size from locked frame geometry. Confirm before a tight install."}, "aluminum|30x90|unframed": {"display": "About 30\u00d790 in (approx.)", "outer_in": [30.0, 90.0], "outer_mm": [762, 2286], "note": "Approximate finished outer size from locked frame geometry. Confirm before a tight install."}, "acrylic|30x90|black": {"display": "About 31.7\u00d791.7 in (approx.)", "outer_in": [31.73, 91.73], "outer_mm": [806, 2330], "note": "Approximate finished outer size from locked frame geometry. Confirm before a tight install."}, "aluminum|30x90|black": {"display": "About 31.7\u00d791.7 in (approx.)", "outer_in": [31.73, 91.73], "outer_mm": [806, 2330], "note": "Approximate finished outer size from locked frame geometry. Confirm before a tight install."}, "acrylic|30x90|natural": {"display": "About 31.7\u00d791.7 in (approx.)", "outer_in": [31.73, 91.73], "outer_mm": [806, 2330], "note": "Approximate finished outer size from locked frame geometry. Confirm before a tight install."}, "aluminum|30x90|natural": {"display": "About 31.7\u00d791.7 in (approx.)", "outer_in": [31.73, 91.73], "outer_mm": [806, 2330], "note": "Approximate finished outer size from locked frame geometry. Confirm before a tight install."}, "acrylic|30x90|white": {"display": "About 31.7\u00d791.7 in (approx.)", "outer_in": [31.73, 91.73], "outer_mm": [806, 2330], "note": "Approximate finished outer size from locked frame geometry. Confirm before a tight install."}, "aluminum|30x90|white": {"display": "About 31.7\u00d791.7 in (approx.)", "outer_in": [31.73, 91.73], "outer_mm": [806, 2330], "note": "Approximate finished outer size from locked frame geometry. Confirm before a tight install."}, "acrylic|30x90|black + border": {"display": "About 35.7\u00d795.7 in (approx.)", "outer_in": [35.67, 95.67], "outer_mm": [906, 2430], "note": "Approximate finished outer size from locked frame geometry. Confirm before a tight install."}, "aluminum|30x90|black + border": {"display": "About 35.7\u00d795.7 in (approx.)", "outer_in": [35.67, 95.67], "outer_mm": [906, 2430], "note": "Approximate finished outer size from locked frame geometry. Confirm before a tight install."}, "acrylic|30x90|natural + border": {"display": "About 35.7\u00d795.7 in (approx.)", "outer_in": [35.67, 95.67], "outer_mm": [906, 2430], "note": "Approximate finished outer size from locked frame geometry. Confirm before a tight install."}, "aluminum|30x90|natural + border": {"display": "About 35.7\u00d795.7 in (approx.)", "outer_in": [35.67, 95.67], "outer_mm": [906, 2430], "note": "Approximate finished outer size from locked frame geometry. Confirm before a tight install."}, "acrylic|30x90|white + border": {"display": "About 35.7\u00d795.7 in (approx.)", "outer_in": [35.67, 95.67], "outer_mm": [906, 2430], "note": "Approximate finished outer size from locked frame geometry. Confirm before a tight install."}, "aluminum|30x90|white + border": {"display": "About 35.7\u00d795.7 in (approx.)", "outer_in": [35.67, 95.67], "outer_mm": [906, 2430], "note": "Approximate finished outer size from locked frame geometry. Confirm before a tight install."}, "acrylic|30x90|gallery": {"display": "About 38.0\u00d798.0 in (approx.)", "outer_in": [38.03, 98.03], "outer_mm": [966, 2490], "note": "Approximate finished outer size from locked frame geometry. Confirm before a tight install."}, "acrylic|30x90|gallery + border": {"display": "About 42.2\u00d7102.2 in (approx.)", "outer_in": [42.2, 102.2], "outer_mm": [1072, 2596], "note": "Approximate finished outer size from locked frame geometry. Confirm before a tight install."}, "canvas|20x60|unframed": {"display": "20\u00d760 in", "outer_in": [20, 60], "outer_mm": [508, 1524], "note": "Approximate finished outer size from locked frame geometry. Confirm before a tight install."}, "canvas|20x60|black": {"display": "About 23.1\u00d763.1 in (approx.)", "outer_in": [23.11, 63.11], "outer_mm": [587, 1603], "note": "Approximate finished outer size from locked frame geometry. Confirm before a tight install."}, "canvas|20x60|natural": {"display": "About 23.1\u00d763.1 in (approx.)", "outer_in": [23.11, 63.11], "outer_mm": [587, 1603], "note": "Approximate finished outer size from locked frame geometry. Confirm before a tight install."}, "canvas|20x60|white": {"display": "About 23.1\u00d763.1 in (approx.)", "outer_in": [23.11, 63.11], "outer_mm": [587, 1603], "note": "Approximate finished outer size from locked frame geometry. Confirm before a tight install."}};
  function mfacNormSize(s) {
    s = String(s || '').toLowerCase().replace(/[″"]/g, '').replace(/×/g, 'x');
    var m = s.match(/(\d+)\s*[x×]\s*(\d+)/) || s.match(/(\d+).*?(\d+)/);
    return m ? m[1] + 'x' + m[2] : s.trim();
  }
  function mfacNormFrame(f) {
    f = String(f || '').toLowerCase().replace(/＋/g, '+');
    f = f.replace(/\s+/g, ' ').replace(/\s*\+\s*/g, ' + ').trim();
    var map = {
      'no frame': 'unframed', none: 'unframed', unframed: 'unframed',
      black: 'black', natural: 'natural', maple: 'natural', white: 'white',
      'black + border': 'black + border', 'natural + border': 'natural + border', 'white + border': 'white + border',
      gallery: 'gallery', 'gallery + border': 'gallery + border'
    };
    return map[f] || f;
  }
  function mfacNormPres(p) {
    p = String(p || '').toLowerCase();
    if (/acryl/.test(p)) return 'acrylic';
    if (/alum|metal/.test(p)) return 'aluminum';
    if (/canvas/.test(p)) return 'canvas';
    return p;
  }
  function mfacFinishedOuter(presentation, size, frame) {
    var key = mfacNormPres(presentation) + '|' + mfacNormSize(size) + '|' + mfacNormFrame(frame);
    return MFAC_OR_OUTER[key] || null;
  }

  function updateInquiryAndPanel(pr, variant, presentation, size, frame, unavailable) {
    var titleEl = document.querySelector('[data-mfac-sel-title]');
    var title = (titleEl && titleEl.textContent) || ((document.querySelector('[data-product-title]') || { getAttribute: function () { return ''; } }).getAttribute('data-product-title')) || document.title.split('—')[0].trim() || '';
    var pres = displayPresentation(presentation);
    var fr = displayFrame(frame);
    var priceTxt = unavailable ? 'Unavailable' : variant ? moneyFromCents(variant.price) : '—';
    var set = function (sel, val) {
      document.querySelectorAll(sel).forEach(function (n) {
        n.textContent = val;
      });
    };
    set('[data-mfac-sel-presentation]', pres || '—');
    set('[data-mfac-sel-size]', size || '—');
    set('[data-mfac-sel-frame]', fr || '—');
    set('[data-mfac-sel-price]', priceTxt);
    var outer = (!unavailable && presentation && size && frame) ? mfacFinishedOuter(presentation, size, frame) : null;
    set('[data-mfac-sel-finished]', outer ? outer.display : 'Ask for confirmed specification');
    set('[data-mfac-sel-weight]', 'Ask for confirmed specification');
    var note = document.querySelector('[data-mfac-sel-status]');
    if (note) {
      if (outer && outer.note) {
        note.hidden = false;
        note.textContent = outer.note;
      } else if (!unavailable) {
        note.hidden = false;
        note.textContent = 'Finished outer size for this combination — ask for confirmed specification before a tight install.';
      }
    }

    // Selection line
    var parts = [];
    if (pres) parts.push(pres);
    if (size) parts.push(size);
    if (fr) parts.push(fr);
    var line = unavailable ? (parts.join(' · ') + ' · Unavailable') : parts.length ? parts.join(' · ') : '—';
    document.querySelectorAll('[data-mfac-selection-line]').forEach(function (n) {
      n.textContent = line;
    });

    // Inquiry mailto — preserve only if user is mid-edit of a real form (none today)
    var links = document.querySelectorAll('[data-mfac-inquiry-link], a[href^="mailto:aloha@mauifineartcollective.com"]');
    var variantId = variant && variant.id ? String(variant.id) : '';
    var url = window.location.origin + window.location.pathname + (variantId ? '?variant=' + variantId : '');
    var subject = 'Ask about this selection: ' + title;
    var body =
      'Selection:\n' +
      title +
      '\n' +
      url +
      '\n' +
      'Variant ID: ' +
      (variantId || '(unavailable combo)') +
      '\n' +
      'Presentation: ' +
      (pres || '') +
      '\n' +
      'Size: ' +
      (size || '') +
      '\n' +
      'Frame: ' +
      (fr || '') +
      '\n' +
      'Finished outer: ' +
      (outer ? outer.display : 'ask for confirmed specification') +
      '\n' +
      'Price: ' +
      priceTxt +
      '\n';
    links.forEach(function (a) {
      // 2026-10-09 (2.6): the see-it-in-room "Ask about scale and placement" link keeps its own subject/label
      if (a.hasAttribute('data-sir-ask')) return;
      // Skip unrelated mailto in footer if no data attr and not in collect peers
      if (!a.hasAttribute('data-mfac-inquiry-link') && !a.closest('[data-mfac-collect-peers], .mfac-advisory-peer, .mfac-selected-artwork')) {
        if (!/Ask about/i.test(a.textContent || '')) return;
      }
      a.setAttribute('href', 'mailto:aloha@mauifineartcollective.com?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body));
      if (a.hasAttribute('data-mfac-inquiry-link') || /Ask about|Email aloha/i.test(a.textContent || '')) {
        a.textContent = 'Ask about this selection';
      }
    });
  }

  function updateSelectionLine(pr) {
    var presentation = displayPresentation(selectedValue(pr, ['presentation', 'material', 'Presentation', 'Material']));
    var size = selectedValue(pr, ['size', 'image-size', 'Size', 'Image Size']);
    var frame = displayFrame(selectedValue(pr, ['frame', 'frame-style', 'Frame', 'Frame Style']));
    var parts = [];
    if (presentation) parts.push(presentation);
    if (size) parts.push(size);
    if (frame) parts.push(frame);
    var line = parts.length ? parts.join(' · ') : '—';
    document.querySelectorAll('[data-mfac-selection-line]').forEach(function (n) {
      n.textContent = line;
    });
    document.querySelectorAll('[data-mfac-pres-panel]').forEach(function (panel) {
      var key = (panel.getAttribute('data-mfac-pres-panel') || '').toLowerCase();
      var show = true;
      if (key === 'acrylic') show = /^acrylic$/i.test(presentation);
      else if (key === 'aluminum' || key === 'metal') show = /^aluminum$/i.test(presentation);
      else if (key === 'canvas') show = /^canvas$/i.test(presentation);
      else if (key === 'gallery') show = /gallery/i.test(frame);
      else if (key === 'border') show = /border/i.test(frame);
      else if (key === 'framed') show = frame && !/^unframed$/i.test(frame) && !/^no frame$/i.test(frame);
      panel.hidden = !show;
      panel.style.display = show ? '' : 'none';
    });
  }

  function rewriteOptionLabels(root) {
    var scope = root || document;
    scope.querySelectorAll('.variant-input[data-value], [data-value].variant-input, .variant-wrapper [data-value]').forEach(function (el) {
      var v = el.getAttribute('data-value') || '';
      var label = el.querySelector('label') || (el.matches('label') ? el : null);
      if (!label) return;
      var mapped = null;
      if (/^metal$/i.test(v)) mapped = 'Aluminum';
      else if (/^luxury$/i.test(v) || /^deep$/i.test(v) || /^wide gallery$/i.test(v) || /^wide gallery frame$/i.test(v)) mapped = 'Gallery';
      else if (/luxury.*border/i.test(v) || /deep.*border/i.test(v) || /wide gallery.*border/i.test(v) || /^gallery w\/ border$/i.test(v) || /^gallery \+ border$/i.test(v))
        mapped = 'Gallery + Border';
      if (mapped) label.textContent = mapped;
    });
  }

  var _guardBusy = false;
  function runGuards(pr) {
    if (_guardBusy) return;
    _guardBusy = true;
    try {
      applyCanvasGalleryGuard(pr);
      updateSelectionLine(pr);
      rewriteOptionLabels(pr);
      applyAvailabilityGuards(pr);
    } finally {
      _guardBusy = false;
    }
  }

  function boot() {
    var pr = productRoot();
    if (!pr || !isLancePhotoContext(pr)) return;
    pr.setAttribute('data-mfac-pres-os-bound', '1');
    // Prefetch product JSON for OR
    try {
      var handle = pr.getAttribute('data-product-handle') || ((location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1]) || '';
      if (handle && !window.MFAC_OR_VARIANTS) {
        fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
          .then(function (r) {
            return r.json();
          })
          .then(function (p) {
            if (p && p.variants) {
              window.MFAC_OR_VARIANTS = p.variants;
              runGuards(productRoot());
            }
          })
          .catch(function () {});
      }
    } catch (e) {}
    runGuards(pr);
    pr.addEventListener(
      'change',
      function (e) {
        if (!e.target || !e.target.matches) return;
        if (e.target.matches('input[data-variant-input], input[type="radio"]')) {
          runGuards(pr);
        }
      },
      true
    );
    document.addEventListener('shopify:section:load', function () {
      runGuards(productRoot());
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
